import React, { useState } from 'react'
import Layout from '../Layout'
import { Box, Container } from '@material-ui/core'
import WebcamCapture from '../Preventive Maintenance/WebcamCapture'

const Camera = () => {
    const [capturedImage, setCapturedImage] = useState(null);
    const handleCapture = (imageSrc) => {
        setCapturedImage(imageSrc);
        // localStorage.setItem('capturedImage', imageSrc);
        console.log('Image saved to local storage', imageSrc);
    };

    return (
        <Layout>
            <Container>
                <Box className='checkpoint-box' mb={2}>
                    <WebcamCapture onCapture={handleCapture} />
                </Box>
            </Container>
        </Layout>
    )
}

export default Camera